import React from "react";

const InfiniteLogoCarousel = () => {
  // Sample company logos - replace with your actual logo URLs
  const logos = [
    {
      id: 1,
      name: "Apple",
      url: require("../../assets/aboutus/appleFinalLogo.png"),
    },
    {
      id: 2,
      name: "AWS",
      url: require("../../assets/aboutus/awsP-removebg-preview.png"),
    },
    {
      id: 3,
      name: "Brightcover",
      url: require("../../assets/aboutus/2brightCove2-Photoroom.png"),
    },
    {
      id: 4,
      name: "Clevertap",
      url: require("../../assets/aboutus/CLEVERTAPp-removebg-preview.png"),
    },
    {
      id: 5,
      name: "Conviva",
      url: require("../../assets/aboutus/CONVIVAp-removebg-preview.png"),
    },
    {
      id: 6,
      name: "Fastly",
      url: require("../../assets/aboutus/fastlyP-removebg-preview.png"),
    },
    {
      id: 7,
      name: "Firebase",
      url: require("../../assets/aboutus/2firebase2-Photoroom.png"),
    },
    {
      id: 8,
      name: "Google",
      url: require("../../assets/aboutus/googlePP-removebg-preview.png"),
    },
    {
      id: 9,
      name: "Impact",
      url: require("../../assets/aboutus/22222impact-Photoroom.png"),
    },
    {
      id: 10,
      name: "Irdeto",
      url: require("../../assets/aboutus/2irdeto2-Photoroom.png"),
    },
    {
      id: 11,
      name: "Kaltura",
      url: require("../../assets/aboutus/2kaltura2-Photoroom.png"),
    },
    {
      id: 12,
      name: "LG",
      url: require("../../assets/aboutus/lgP-removebg-preview.png"),
    },
    {
      id: 13,
      name: "Samsung",
      url: require("../../assets/aboutus/samsungLogoFinal.png"),
    },
    {
      id: 14,
      name: "SDMC",
      url: require("../../assets/aboutus/2sdmc2-Photoroom.png"),
    },
    {
      id: 15,
      name: "Seiro",
      url: require("../../assets/aboutus/seiRobot.png"),
    },
    {
      id: 16,
      name: "Vidaa",
      url: require("../../assets/aboutus/VIDAAp-removebg-preview.png"),
    },
    {
      id: 17,
      name: "Youbora",
      url: require("../../assets/aboutus/YOUBORAp-removebg-preview.png"),
    },
  ];

  // Duplicate the logos array to create seamless loop
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {duplicatedLogos.map((logo, index) => (
          <div key={`${logo.id}-${index}`} className="logo-item">
            <img src={logo.url} alt={logo.name} className="logo-image" />
          </div>
        ))}
      </div>

      <style jsx>{`
                .carousel-container {
          width: 100vw;
          height:"200px"
          overflow: hidden;
          background: transparent;
          padding: 40px 0;
          position: relative;
          white-space: nowrap;
        }

        .carousel-track {
          display: inline-flex;
          animation: scroll 30s linear infinite;
          gap: 60px;
        }

        .logo-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          background: transparent;
          border-radius: 0;
          box-shadow: none;
          transition: transform 0.3s ease;
          backdrop-filter: none;
          min-width: 180px;
          height: 120px;
        }

        .logo-item:hover {
          transform: scale(1.1);
        }

        .logo-image {
          width: 150px;
          max-height: 80px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }


        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${logos.length * 240}px);
          }
        }

        /* Pause animation on hover */
        .carousel-container:hover .carousel-track {
          animation-play-state: paused;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .carousel-track {
            gap: 40px;
            animation: scroll-mobile 25s linear infinite;
          }

          .logo-item {
            min-width: 140px;
            height: 100px;
            padding: 15px;
          }

          .logo-image {
            max-width: 120px;
            max-height: 60px;
          }

          @keyframes scroll-mobile {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-${logos.length * 180}px);
            }
          }
        }

        @media (max-width: 480px) {
          .carousel-container {
            padding: 30px 0;
          }

          .carousel-track {
            gap: 30px;
            animation: scroll-small 20s linear infinite;
          }

          .logo-item {
            min-width: 120px;
            height: 80px;
            padding: 10px;
          }

          .logo-image {
            max-width: 100px;
            max-height: 50px;
          }

          @keyframes scroll-small {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-${logos.length * 150}px);
            }
          }
        }
      `}</style>
    </div>
  );
};

export default InfiniteLogoCarousel;
